"use client";

import { PanelLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebarStore } from "@/hooks/use-sidebar-store";

export function MobileSidebarTrigger() {
  const toggle = useSidebarStore((state) => state.toggle);

  return (
    <Button
      variant='outline'
      size='icon'
      onClick={(e) => {
        e.stopPropagation();
        toggle();
      }}
      className='h-10 w-10 border-muted-foreground/20'
    >
      <PanelLeft className='h-[1.2rem] w-[1.2rem]' />
      <span className='sr-only'>Toggle Sidebar</span>
    </Button>
  );
}
